import { DataTable } from "primereact/datatable";
import { useEffect, useState, Suspense, useRef } from "react";
import { ColumnDef } from "../../models/orders/order-list-model";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import AppLoading from '../app-loading/app-loading';  
import orderServices from "../../services/orders/orderservice";
import { InputText } from 'primereact/inputtext';
import InvoicePayment from "../invoices/invoice-payment";
import { Toast } from 'primereact/toast';
import RouteConstant from "../../constants/route.constants";
import { useNavigate } from "react-router-dom";
import { GetWayLinkModel } from "../../models/getway-link/getway-link-model";
import { selectedGetway } from "../../redux/slices/getway-link";
import { useAppDispatch } from "../../redux/hooks";

interface DataTableProps {
  dataList: [];
}

const PaymentLinkListDataTable: React.FC<DataTableProps> = (dataList) => {
  const [orderDataList, setOrderDataList] = useState<any>();
  const [visible, setVisible] = useState(false);
  const [rowData,setRowData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [paymentModeId, setPaymentModeId] = useState<any>('0');
  const toast = useRef<Toast>(null);
  const [value, setValue] = useState('');
  const dispatch = useAppDispatch();
  var navigate = useNavigate();

  useEffect(() => {
    setOrderDataList(dataList.dataList);
  },[dataList]);

   function handlePaymentLink(row:any){
    setVisible(true);
    setRowData(row)
   }


    const mapAdditionalInfo = (data: any): GetWayLinkModel => {
    return {
      paymentURL: data.paymentURL,
      expectedDeliveryDate: data.expectedDeliveryDate,
    };
  };

  const columns: ColumnDef[] = [

    {
        header: "Receive Payment",
        cell: (row: any) =>(
        <Button
         icon="pi pi-link"
         onClick={() => handlePaymentLink(row)}
         style={{ border: 'none', color: 'tomato', background: 'none'}}
         className="p-button-rounded"
         tooltip="Send Link"
        />)        
    },
    {
      field: "lastLinkDate",
      header: "Last Sent Date",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
      new Date(row.lastLinkDate).toLocaleDateString("en-gb", {
          day: "2-digit",
          month: "short",
          year: "numeric",
      }),
    },
    {
      field: "invoiceNo",
      header: "Invoice #",
      style: { minWidth: "5rem" },
      sortable:true,
    },
    {
      field: "invoiceDate",
      header: "Invoice Date",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
      new Date(row.invoiceDate).toLocaleDateString("en-gb", {
          day: "2-digit",
          month: "short",
          year: "numeric",
      }),
    },
    {
      field: "invoiceBy",
      header: "Invoice By",
      style: { minWidth: "9rem" },
      sortable:true,
    },
    {
      field: "ageDate",
      header: "Ageing",
      style: { minWidth: "9rem" },
      sortable:true,
    },
    {
      field: "grossAmount",
      header: "Gross Amount",
      style: { minWidth: "5rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.grossAmount).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "customerName",
      header: "Customer Name",
      style: { minWidth: "9rem" },
      sortable:true,
    },
      {
      field: "primaryContactNo",
      header: "Customer No#",
      style: { minWidth: "5rem" },
      sortable:true,
    },
  ];


  const hideDialog = () => {
    setVisible(false);
  };

  function handelSubmit(){
   if(paymentModeId === '0' || paymentModeId === 5){
                 toast.current?.show({
             severity: 'info',
             summary: 'Info',
             detail: 'Please select the payment mode.',
             life: 3000
        });
   }
   else{
    var paradata = {
        "orderId": rowData.orderId,
        "customerId": rowData.customerId,
        "customerName": rowData.customerName,
        "primaryContactNo": value !== "" ? value : rowData.primaryContactNo,
        "grossAmount": rowData.grossAmount,
        "paymentModeId": paymentModeId,
        "invoiceId" : rowData.invoiceId,
        "customerEmail": rowData.customerEmail
    }
    orderServices.updateActualpayment(paradata).then((response:any) => {
        if(response.isSuccess){
           if(paymentModeId === "7") {
            const getwayData = response.additionalInfo;
            dispatch(selectedGetway(mapAdditionalInfo(getwayData)));
            navigate(RouteConstant.getwayProcess);
          }
          if(paymentModeId === "6"){
            setLoading(true);
            toast.current?.show({
             severity: 'success',
             summary: 'Success',
             detail: response.message,
             life: 3000
           });
           setVisible(false);
           setLoading(false);
          }
          if(paymentModeId === "1"){
            setLoading(true);
            toast.current?.show({
             severity: 'success',
             summary: 'Success',
             detail: "PaymentMode Update Success",
             life: 3000
           });
            setVisible(false);
            setLoading(false);
          }
        }  
     })
   }
  }  

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} />
          <div className="col-12 card border-noround p-2">
            <DataTable
                value={orderDataList}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                stripedRows
                showGridlines
                sortMode="multiple"
                emptyMessage="No Record found."
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
              >
              {columns.map((col, i) => (
                <Column
                  key={i}
                  field={col.field}
                  header={col.header}
                  sortable={col.sortable}
                  style={col.style}
                  body={col.cell}
                />
              ))}
            </DataTable>
            <Dialog 
              visible={visible} 
              style={{ width: "67vw" }} 
              header={"Select payment mode"}
              onHide={hideDialog}
            >
            <div className="col-12">
               <div className="pl-3 mb-3">
                <InvoicePayment updatePaymentId={setPaymentModeId} /><br />
            </div>
            {
              paymentModeId === "6" ? 
              <div className="col-12 card border-noround p-2"> 
                  <div className="col-12">
                    <div className="flex justify-content-start mb-2">
                      <div className="flex align-items-center gap-2 p-2 border-round" 
                          style={{  backgroundColor: 'var(--blue-50)',  border: '1px solid var(--blue-100)', display: 'inline-flex', maxWidth: 'fit-content' }}>
                          <i className="pi pi-info-circle" style={{ color: 'var(--blue-600)', fontSize: '1.25rem' }} />
                          <span style={{ color: 'var(--blue-700)' }}>if you leave the phone number blank, the payment link will automatically be sent to the primary contact number.</span>
                      </div>
                    </div>
                </div>
                <div className="col-6">
                  <div className="flex-auto">
                      <label htmlFor="number" className="font-bold block mb-2">
                        Phone Number
                      </label>
                      <InputText value={value} id="number" keyfilter="num" style={{ border: '1px solid #ced4da', borderRadius: '4px' }} onChange={(e) => setValue(e.target.value)} />
                  </div>
                </div>
              </div> : ""
            }
            <div className="col-12">
              <Button onClick={handelSubmit}>Submit</Button>
            </div>
          </div>
            </Dialog>
          </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default PaymentLinkListDataTable;